var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.4,
    height: 38.4,
    viewBox: "0 0 38.4 38.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_83_1",
    "data-name": "Component 83 \\u2013 1",
    transform: "translate(1.7 1.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1",
    "data-name": "Path 1",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,0A17.5,17.5,0,1,1,0,17.5,17.5,17.5,0,0,1,17.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.5 0 C 7.835020065307617 0 0 7.835020065307617 0 17.5 C 0 27.16497993469238 7.835020065307617 35 17.5 35 C 27.16497993469238 35 35 27.16497993469238 35 17.5 C 35 7.835020065307617 27.16497993469238 0 17.5 0 M 17.5 -1.700000762939453 C 20.09123039245605 -1.700000762939453 22.60585975646973 -1.192119598388672 24.97402954101562 -0.1904716491699219 C 27.26054954528809 0.7766494750976562 29.31369972229004 2.160808563232422 31.07645034790039 3.923549652099609 C 32.83919143676758 5.686300277709961 34.22335052490234 7.739450454711914 35.19047164916992 10.02597045898438 C 36.19211959838867 12.39414024353027 36.70000076293945 14.90876960754395 36.70000076293945 17.5 C 36.70000076293945 20.09123039245605 36.19211959838867 22.60585975646973 35.19047164916992 24.97402954101562 C 34.22335052490234 27.26054954528809 32.83919143676758 29.31369972229004 31.07645034790039 31.07645034790039 C 29.31369972229004 32.83919143676758 27.26054954528809 34.22335052490234 24.97402954101562 35.19047164916992 C 22.60585975646973 36.19211959838867 20.09123039245605 36.70000076293945 17.5 36.70000076293945 C 14.90876960754395 36.70000076293945 12.39414024353027 36.19211959838867 10.02597045898438 35.19047164916992 C 7.739450454711914 34.22335052490234 5.686300277709961 32.83919143676758 3.923549652099609 31.07645034790039 C 2.160808563232422 29.31369972229004 0.7766494750976562 27.26054954528809 -0.1904716491699219 24.97402954101562 C -1.192119598388672 22.60585975646973 -1.700000762939453 20.09123039245605 -1.700000762939453 17.5 C -1.700000762939453 14.90876960754395 -1.192119598388672 12.39414024353027 -0.1904716491699219 10.02597045898438 C 0.7766494750976562 7.739450454711914 2.160808563232422 5.686300277709961 3.923549652099609 3.923549652099609 C 5.686300277709961 2.160808563232422 7.739450454711914 0.7766494750976562 10.02597045898438 -0.1904716491699219 C 12.39414024353027 -1.192119598388672 14.90876960754395 -1.700000762939453 17.5 -1.700000762939453 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-menu",
    "data-name": "Icon open-menu",
    d: "M0,0V1.755H14.043V0Z",
    transform: "translate(10.159 11.009)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-menu-2",
    "data-name": "Icon open-menu",
    d: "M0,0V1.755H14.043V0Z",
    transform: "translate(10.159 16.009)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-menu-3",
    "data-name": "Icon open-menu",
    d: "M0,0V1.755H14.043V0Z",
    transform: "translate(10.159 21.009)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToggle);
export default __webpack_public_path__ + "static/media/icon-toggle.9c6676b0a2cca654f3fc07f5776428a2.svg";
export { ForwardRef as ReactComponent };